import { useBasketMemo, BasketMemo } from "@bundles/basket"
import { returnBasketMemo } from "@bundles/basket/hooks/useBasketMemo"
import { useWorkTask } from "@tm/context-distribution"
import { ArticleListType, PureArticleListType } from "@tm/models"
import { PropsWithChildren } from "react"
import { createContext, useContext } from "use-context-selector"
import { ensureContextAvailability } from "../../helpers"
import { useCombinedListParamsContext } from "../ListParams"

export const BasketMemoContextContext = createContext<BasketMemo>(returnBasketMemo())

export function BasketMemoProvider({ children }: PropsWithChildren) {
    const { workTask } = useWorkTask()
    const listType = useCombinedListParamsContext((x) => x.listType)
    const basketMemo = useBasketMemo(workTask, GetIsNotVehicleDependentFromListType(listType))

    return <BasketMemoContextContext.Provider value={basketMemo}>{children}</BasketMemoContextContext.Provider>
}

export function useBasketMemoContext(): BasketMemo {
    const context = useContext(BasketMemoContextContext)
    return ensureContextAvailability("BasketMemoContextContext", context)
}

function GetIsNotVehicleDependentFromListType(listType: ArticleListType | PureArticleListType): boolean {
    switch (listType) {
        case "vehicle":
        case "productGroups":
        case "wholesalerArticleNumber":
        case "oe":
            return false

        case "direct":
        case "universal":
            return true

        case "offers":
        case "compilation":
        case "carousel":
            return true

        case "alternative":
        case "suggestion":
        case "recommended-articles":
            return true

        case "partslist":
        case "accessoryList":
        case "mainAccessoryList":
        case "articlesAlreadyOrderedList":
        case "mainPartsList":
            return false

        case "tyresList":
            return true

        case "wheelsOverview":
        case "wheelsTyresList":
        case "wheelsSensorsList":
        case "damageModulesList":
            return false

        case "pure":
        case "default":
        default:
            return false // default value is false, to keep old broken logic, meaning undefined is vehicle dependent
    }
}
